export default {
  "button": "_button_1hw4to",
  "toggle": "_toggle_1hw4to",
  "toggle__control": "_toggle__control_1hw4to"
};